import moment from 'moment'
export function date_format(value,options={}){
  let moment_instance = null, response  = ''
  try {
    if(value==undefined) return ''
    if(options?.input?.unix) moment_instance = moment.unix(value)
    else moment_instance = moment.utc(value)
    if(options?.input?.local) moment_instance = moment_instance.local() 
    if(options?.output?.formate) response = moment_instance.format(options.output.formate)
    else if(options?.output?.from_now) response = moment_instance.fromNow()
    else if(options?.output?.calender) response = moment_instance.calendar(null, {
      sameDay: options?.output?.calender?.sameDay || '[Today]',
      nextDay: options?.output?.calender?.nextDay || '[Tomorrow]',
      nextWeek: options?.output?.calender?.nextWeek || 'dddd',
      lastDay: options?.output?.calender?.lastDay || '[Yesterday]',
      lastWeek: options?.output?.calender?.lastWeek || '[Last] dddd',
      sameElse: options?.output?.calender?.sameElse || 'DD MMM YYYY'
    })
    else response = moment_instance.format('DD-MMM-YYYY hh:mm:ss A')
    if(response=='Invalid date') response=''
    if(options?.same){
      let other_moment = options?.same?.date
      other_moment = moment.utc(options?.same?.date)
      if(options?.input?.local) other_moment = other_moment.local() 
      response = moment_instance.isSame(other_moment,options?.same?.type) ? undefined : options?.same?.date;
    } 
    if(options?.output?.default && (!response || response=='Invalid date')) response=options?.output?.default 
    return response
  } finally {
    if(options?.output?.default && (!response || response=='Invalid date')) response=options?.output?.default 
    // eslint-disable-next-line no-unsafe-finally
    return response
  }
}